(() => {
  const ENDPOINT = 'https://api.judge.me/api/v1/widgets/featured_carousel';
  // Judge.me's carousel markup; update here if their class names change.
  const SELECTORS = {
    item: '.jdgm-carousel-item',
    body: '.jdgm-carousel-item__review-content',
    name: '.jdgm-carousel-item__reviewer-name'
  };

  const extractHtml = (raw) => {
    try {
      const payload = JSON.parse(raw);
      if (typeof payload === 'string') return payload;
      const html = Object.values(payload || {}).find((value) => typeof value === 'string' && value.includes('<'));
      return html || '';
    } catch (error) {
      return raw;
    }
  };

  const parseReviews = (html, limit) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    return Array.from(doc.querySelectorAll(SELECTORS.item))
      .map((item) => {
        const body = item.querySelector(SELECTORS.body);
        const name = item.querySelector(SELECTORS.name);
        return {
          text: body ? body.textContent.trim() : '',
          name: name ? name.textContent.trim() : ''
        };
      })
      .filter((review) => review.text)
      .slice(0, limit);
  };

  const truncate = (text, maxChars) => {
    if (!maxChars || text.length <= maxChars) return text;
    const cut = text.slice(0, maxChars);
    const lastSpace = cut.lastIndexOf(' ');
    const trimmed = lastSpace > maxChars * 0.6 ? cut.slice(0, lastSpace) : cut;
    return `${trimmed.replace(/[\s.,;:!?-]+$/, '')}…`;
  };

  const render = (carousel, reviews) => {
    const template = carousel.querySelector('[data-testimonial-template]');
    const slidesWrap = carousel.querySelector('[data-testimonial-slides]');
    const dotsWrap = carousel.querySelector('[data-testimonial-dots]');
    const dotLabel = carousel.dataset.dotLabel || '';
    const maxChars = Number(carousel.dataset.maxChars) || 0;

    reviews.forEach((review, index) => {
      const slide = template.content.firstElementChild.cloneNode(true);
      slide.dataset.index = index;
      slide.classList.toggle('is-active', index === 0);
      slide.querySelector('[data-testimonial-quote]').textContent = `“${truncate(review.text, maxChars)}”`;

      const nameEl = slide.querySelector('[data-testimonial-name]');
      if (review.name) {
        nameEl.textContent = review.name;
      } else {
        nameEl.remove();
      }
      slidesWrap.appendChild(slide);

      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `testimonial-slide__dot${index === 0 ? ' is-active' : ''}`;
      dot.dataset.target = index;
      dot.setAttribute('aria-label', dotLabel.replace('__number__', index + 1));
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dotsWrap.appendChild(dot);
    });
  };

  const load = async (carousel) => {
    const { shopDomain, apiToken, limit } = carousel.dataset;
    if (!shopDomain || !apiToken) return;

    carousel.querySelector('[data-testimonial-slides]').replaceChildren();
    carousel.querySelector('[data-testimonial-dots]').replaceChildren();

    let reviews = [];
    try {
      const params = new URLSearchParams({ shop_domain: shopDomain, api_token: apiToken });
      const response = await fetch(`${ENDPOINT}?${params}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(response.status);
      reviews = parseReviews(extractHtml(await response.text()), Number(limit) || 5);
    } catch (error) {
      reviews = [];
    }

    if (!reviews.length) {
      carousel.hidden = true;
      return;
    }

    carousel.hidden = false;
    render(carousel, reviews);
    carousel.dispatchEvent(new CustomEvent('testimonials:ready', { bubbles: true }));
  };

  const init = () => document.querySelectorAll('[data-judgeme-testimonials]').forEach(load);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-judgeme-testimonials]').forEach(load);
  });
})();
